module.exports = __webpack_public_path__ + "static/img/wx-phone.4cf3250.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/wx-phone.png
// module id = xBq5
// module chunks = 4